import React from 'react';
import Slider from '../../vendor/react-slick/slider';
import LazyloadImage from "../LazyloadImage";
import PrevArrow from '../CarouselArrows/prev-arrow';
import NextArrow from '../CarouselArrows/next-arrow';
import { isMobile } from "../../utilities/javascript/browser";
import styles from './styles.css';

export default class ArticleCarousel extends React.Component {
  constructor(props) {
    super(props);
    const isMobile = props.isMobile;
    this.state = {
      arrows: !isMobile,
      slidesToShow: isMobile ? 2.5 : 5,
      cardStyle: isMobile ? { width: 150 } : { width: 270 }
    }
  }

  static defaultProps = {
    designerName: '',
    articleCardsInfos: ''
  };

  onWindowResize() {
    this.setState({
      arrows: !isMobile(),
      slidesToShow: isMobile() ? 2 : 3,
      cardStyle: isMobile() ? { width: 150 } : { width: 270 }
    })
  }

  componentDidMount() {
    this.onWindowResize();
    if (window && window.addEventListener) {
      window.addEventListener('resize', this.onWindowResize.bind(this))
    }
  }

  render() {
    const { designerName, articleCardsInfos } = this.props;
    const { arrows, slidesToShow, cardStyle } = this.state;
    const settings = {
      arrows: arrows,
      infinite: false,
      slidesToShow: slidesToShow,
      swipeToSlide: true,
      variableWidth: true,
      className: `${styles['slick-slider']}`,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
    };

    let articleCard = function (article, index) {

      let linkingSlug = `https://www.theknot.com/content/${article.linking_slug}`
      return (
        <a id={`article-link-${index}`} href={linkingSlug} target="_blank">
          <LazyloadImage
            containerClassName='content-image-container'
            image={article.img_id}
            alt={article.img_alt}
            desktopWidth={256}
            desktopHeight={135}
            mobileWidth={160}
            mobileHeight={88}
            smartCrop={false}
          />
          <div className={styles['panel-heading']}>
            <h3 style={{ '-webkit-box-orient': 'vertical' }}>{article.headline}</h3>
          </div>
        </a>
      )
    }

    return (
      <div className={styles['article-and-advice-container']}>
        <div className={styles['section-title']}>
          <h3>Articles & Advice</h3>
          from {designerName}
        </div>
        <Slider {...settings}>
          {
            articleCardsInfos.map(function (article, index) {
              return <div style={cardStyle} className={styles['article-card']}>
                {
                  articleCard(article, index)
                }
              </div>
            })
          }
        </Slider>
      </div>
    )
  }
}